import { createAsyncThunk } from '@reduxjs/toolkit';
import getCredentials from '../../../../utils/getCredentials';
import { getDefaultCompanies } from '../services/getDefaultCompanies.service';

// Fetches the global "default" company rows for the given company_bids and
// returns them so they can be merged into the companies slice. Callers should
// only pass bids that have no saved tenant row, so a real tenant row always
// wins and we never fetch a default we won't use.
export const loadDefaultCompanies = createAsyncThunk(
    'filings/loadDefaultCompanies',
    async (companyBids) => {
        if (!companyBids || !companyBids.length) {
            return { companies: [] };
        }

        // Ensure session credentials are valid before the signed request.
        await getCredentials();

        const response = await getDefaultCompanies(companyBids);

        return {
            companies: response.Items || [],
        };
    }
);
